import React from 'react'

const HalfStepBar = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="4" height="29" viewBox="0 0 4 29">
	  <rect id="Rectangle_1798" data-name="Rectangle 1798" width="4" height="29" rx="2" fill={props.fill}/>
	</svg>
)

export default HalfStepBar